<template>
  <a-input-group :class="setClass">
    <a-select
      :style="{ width: leftWidth + 'px', height: height + 'px' }"
      :placeholder="leftText"
      v-model="state.parentSelect"
      @change="emit('update:select', state.parentSelect)"
    >
      <a-option
        v-for="(item, index) in state.seletList"
        :key="index"
        :value="typeof item === 'string' ? item : item[value] || ''"
        :label="typeof item === 'string' ? item : item[label] || ''"
      />
    </a-select>
    <a-input
      class="input"
      :style="{ width: rightWidth + 'px', height: height + 'px' }"
      :placeholder="rightText"
      v-model="state.parentInput"
      @change="emit('update:input', state.parentInput)"
    ></a-input>
    <a-button
      :style="{
        'min-width': btnWidth + 'px',
        height: height + 'px',
        'border-radius': `0 ${btnradius}px ${btnradius}px 0`,
      }"
      type="primary"
      @click="handleSearch"
    >
      {{ btnText }}
    </a-button>
  </a-input-group>
</template>

<script setup>
  import { dispatch } from '@/utils/selectList'
  import { computed, defineEmits, defineProps, reactive } from 'vue'
  import { useStore } from 'vuex'

  /* 实例 */
  const store = useStore()
  dispatch(store, {
    path: 'common',
    list: ['marketplace'],
  })

  /* props */
  const props = defineProps({
    setClass: {
      type: String,
      default: '',
    },
    leftText: {
      type: String,
      default: '请选择',
    },
    leftWidth: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 35,
    },
    rightWidth: {
      type: Number,
      default: 200,
    },
    btnWidth: {
      type: Number,
      default: 0,
    },
    rightText: {
      type: String,
      default: '请输入内容',
    },
    btnradius: {
      type: Number,
      default: 4,
    },
    btnText: {
      type: String,
      default: '搜索',
    },
    // 下拉列表参数
    options: {
      type: Array,
      default: () => [],
    },
    // 下拉展示的绑定值
    value: {
      type: String,
      default: '',
    },
    // 下拉展示的名字
    label: {
      type: String,
      default: '',
    },

    // 组件绑定的下拉值 (返回给父组件的)
    select: {
      type: String,
      default: '',
    },
    // 组件绑定的输入框的值 (返回给父组件的)
    input: {
      type: String,
      default: '',
    },
  })

  /* emit */
  const emit = defineEmits(['update:select', 'update:input', 'search'])

  /* state */
  const state = reactive({
    // 默认站点
    seletList:
      props.options.list || computed(() => store.getters['common/marketplace']),

    // 返回父组件的下拉值
    parentSelect: props.select || '',
    // 返回父组件的输入值
    parentInput: props.input || '',
  })

  /* method */

  // 点击搜索按钮
  function handleSearch() {
    emit('search')
  }
</script>

<style lang="less" scoped>
  .arco-input-group > .arco-select-view:not(:last-child):hover {
    border-right: 1px solid rgb(41, 111, 234);
  }
  .arco-input-group > .arco-input-wrapper:last-child:hover {
    border-left: 1px solid rgb(41, 111, 234);
  }
  /deep/.arco-input-wrapper {
    border-left: 1px solid transparent;
  }
  :deep(.arco-btn-primary) {
    // border-radius: 0 5px 5px 0 !important;
  }
</style>
